import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "./pages/Login.jsx";
import Dashboard from "./pages/Dashboard.jsx";

// Single shell. Two routes.
// `/` shows the lobby (login) — or a lockout state if applicable.
// `/dashboard` is the post-login stub. If the user has no session, we
// detect that client-side by calling /api/me and redirect to / on 401.
export default function App() {
  // useLocation here forces a re-render on route change so the live clock
  // and meter remount cleanly per page.
  const location = useLocation();
  return (
    <Routes key={location.pathname}>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
